import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data";
import Reveal from "@/components/landing/Reveal";

export const Services = () => (
  <section id="services" data-testid="services-section" className="bg-white py-24 md:py-32">
    <div className="max-w-[1440px] mx-auto px-5 md:px-12">
      <div className="max-w-3xl">
        <Reveal>
          <span className="font-display uppercase tracking-[0.2em] text-gold text-sm font-semibold">
            02 — What We Do
          </span>
          <h2 className="mt-4 font-display font-bold uppercase text-navy text-4xl md:text-6xl leading-[0.9] tracking-tight">
            Multiple trades. One phone call.
          </h2>
          <p className="mt-5 font-body text-navy/60 text-lg">
            Whatever your space needs, we handle it end-to-end — with craftsmanship
            that shows and communication that never leaves you guessing.
          </p>
        </Reveal>
      </div>

      <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {SERVICES.map((s, i) => {
          const Icon = s.icon;
          return (
            <Reveal key={s.title} delay={(i % 4) * 0.07}>
              <Link
                to={`/services/${s.slug}`}
                className="group relative bg-cloud rounded-2xl p-7 h-full block border border-transparent hover:border-gold/40 hover:bg-white hover:shadow-[0_20px_50px_rgba(12,30,68,0.08)] transition-[background-color,border-color,box-shadow,transform] duration-300 hover:-translate-y-1"
                data-testid={`service-card-${i}`}
              >
                <div className="flex items-start justify-between">
                  <div className="w-14 h-14 rounded-full bg-navy flex items-center justify-center group-hover:bg-gold transition-colors duration-300">
                    <Icon size={24} className="text-gold group-hover:text-navy-dark transition-colors duration-300" strokeWidth={1.8} />
                  </div>
                  <ArrowUpRight size={22} className="text-navy/20 group-hover:text-gold transition-colors duration-300" />
                </div>
                <h3 className="mt-6 font-display font-semibold text-navy text-xl leading-tight">
                  {s.title}
                </h3>
                {s.tag && (
                  <span
                    className="inline-block mt-2.5 rounded-full bg-gold text-navy-dark text-[11px] font-bold uppercase tracking-wide px-3 py-1"
                    data-testid={`service-tag-${i}`}
                  >
                    {s.tag}
                  </span>
                )}
                <p className="mt-3 font-body text-navy/60 text-sm leading-relaxed">{s.desc}</p>
              </Link>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);

export default Services;
